import { type PropsWithChildren, useMemo } from 'react';
import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import { type PageUISave, PageUISaveContext } from '@alltrails/layout/components/PageUI/PageUISaveContext/PageUISaveContext';
import useReduxListItems from '@alltrails/lists/hooks/useReduxListItems';
import type { AnalyticsInfo } from '@alltrails/lists/utils/listAmplitudeHelpers';

const saveAnalyticsInfo: AnalyticsInfo = { detailedCardLocation: 'ask alltrails results', page: PageStrings.ASK_ALLTRAILS_PAGE };

/**
 * A provider to support saving items in Ask's answer to the user's lists.
 */
const AskSaveProvider = ({ children }: PropsWithChildren) => {
  const { handleFavoriteClick, isComplete, isFavorite, isVerified, listModal, signUpModal } = useReduxListItems(
    undefined,
    undefined,
    saveAnalyticsInfo
  );

  const value = useMemo<PageUISave>(
    () => ({
      isCompleted: ({ id, type }) => isComplete(type, id),
      isSaved: ({ id, type }) => isFavorite(type, id),
      isVerified: ({ id, type }) => isVerified(type, id),
      onSaveClick: ({ id, isCustomRoute, type }) => handleFavoriteClick(type, id, undefined, isCustomRoute)
    }),
    [handleFavoriteClick, isComplete, isFavorite, isVerified]
  );

  return (
    <PageUISaveContext.Provider value={value}>
      {children}
      {listModal}
      {signUpModal}
    </PageUISaveContext.Provider>
  );
};

export default AskSaveProvider;
